import styled from 'styled-components';

export const InputTransfer = styled.div`
  position: relative;
`;
